import request from "@/utils/request";

// 列表(主数据列表)
export function loadSupplyUseEfficiencyInfoListDataApi(data) {
    return request({
      url: "web/supplyUseEfficiencyInfo/listData",
      method: "post",
      data
    });
  }
  // 导出
  export function loadSupplyUseEfficiencyInfoExportDataApi(data) {
    return request({
      url: "web/supplyUseEfficiencyInfo/exportData",
      method: "post",
      data
    });
  }
  
  // 保存
  export function saveOrUpdateSupplyUseEfficiencyInfoApi(data) {
    return request({
      url: "web/supplyUseEfficiencyInfo/saveOrUpdate",
      method: "post",
      data
    });
  }
  
  // 查看
  export function initSupplyUseEfficiencyInfoApi(data) {
    return request({
      url: "web/supplyUseEfficiencyInfo/init",
      method: "post",
      data
    });
  }

  // 明细列表(主数据列表)
export function loadSupplyUseEfficiencyInfoDetailListDataApi(data) {
    return request({
      url: "web/supplyUseEfficiencyInfoDetail/listData",
      method: "post",
      data
    });
  }
  // 明细导出
  export function loadSupplyUseEfficiencyInfoDetailExportDataApi(data) {
    return request({
      url: "web/supplyUseEfficiencyInfoDetail/exportData",
      method: "post",
      data
    });
  }